import { Injectable } from "@angular/core";
import { AuthService } from "@saliente/common-auth";
import { BehaviorSubject, from, Subscription } from "rxjs";
import { RestService } from "./rest.service";
import { GetActiveFormCountGQL } from "src/app/client-forms/adapters/clientforms.generated";

@Injectable()
export class ClientFormsCommonService {
    public formCount: BehaviorSubject<number>;
    public allFormCount: BehaviorSubject<number>;
    public duFormCount: BehaviorSubject<number>;

	public allFormCountSubscription: Subscription;
	public duFormCountSubscription: Subscription;


    constructor(private authService: AuthService, private restService: RestService) {
		this.formCount = new BehaviorSubject<number>(0);
		this.allFormCount = new BehaviorSubject<number>(0);
		this.duFormCount = new BehaviorSubject<number>(0);
	}

    public async getActiveFormCount(clientEid: string, formType: string = null, form: string = null): Promise<number> {
		let qry = new GetActiveFormCountGQL(this.restService);
        let filterParts = [];
		if (formType) {
			filterParts.push(`form_type[eq]:${formType}`);
		}
		if (form) {
			filterParts.push(`form[eq]:${form}`);
		}
		let filter = filterParts.length > 0 ? filterParts.join(' AND ') : null;
		let queryData  = await qry.fetch(
			{
				clientEid: clientEid,
                filter: filter
			}
		).toPromise();

		if (queryData != null) {
			let count = queryData.data.accounts.getActiveFormCountUsingGET.count;
            this.formCount.next(count);
		}

		return null;
	}

    public async getAllActiveFormCount(clientEid: string): Promise<number> {
		let qry = new GetActiveFormCountGQL(this.restService);
		let queryData  = await qry.fetch(
			{
				clientEid: clientEid,
                filter: null
			}
		).toPromise();

		if (queryData != null) {
			return queryData.data.accounts.getActiveFormCountUsingGET.count;
		}

		return null;
	}

    public async getDuFormCount(clientEid: string): Promise<number> {
		let qry = new GetActiveFormCountGQL(this.restService);
		let filter = 'form[eq]:du-pfa-keez';
		let queryData  = await qry.fetch(
			{
				clientEid: clientEid,
                filter: filter
			}
		).toPromise();

		if (queryData != null) {
			return queryData.data.accounts.getActiveFormCountUsingGET.count;
		}

		return null;
	}

	public getAllActiveFormCountSubscription() {
		if (this.allFormCountSubscription) { this.allFormCountSubscription.unsubscribe(); this.allFormCountSubscription = null; }

		if (this.authService.user && this.authService.user.selectedCompanyId) {
			this.allFormCountSubscription = from(this.getAllActiveFormCount(this.authService.user.selectedCompanyId))
				.subscribe((count) => {
					if (count != null) {
						this.allFormCount.next(count);
					}
			})
		}
	}

	public getDuFormCountSubscription() {
		if (this.duFormCountSubscription) { this.duFormCountSubscription.unsubscribe(); this.duFormCountSubscription = null; }

		if (this.authService.user && this.authService.user.selectedCompanyId) {
			this.duFormCountSubscription = from(this.getDuFormCount(this.authService.user.selectedCompanyId))
				.subscribe((count) => {
					if (count != null) {
						this.duFormCount.next(count);
					}
			})
		}
	}

    public get activeFormCount(): number {
		return this.formCount?.value;
	}

    public get allActiveFormCount(): number {
		return this.allFormCount?.value;
	}

    public get duActiveFormCount(): number {
		return this.duFormCount?.value;
	}
}